export const FIELD_INFO = {
    name: {
        minLength: 21,
        maxLength: 120,
    },
    description: {
        minLength: 25,
        maxLength: 5000,
    },
    optionName: {
        maxLength: 20,
    },
    maxImages: 10,
    maxImagesLevel: 'product_or_stock_unit',
} as const
